import type { ReactNode } from 'react';
import { PageContainer } from '../PageContainer/PageContainer';
import { TemplateSection } from './Section';

export type ForEmployersTemplateProps = {
  /** The dark pitch panel (a CtaBand, or a Hero inside one) with the page's one primary action. */
  pitch: ReactNode;
  /** How it works, as a Timeline or Steps. */
  howItWorks?: { title: ReactNode; content: ReactNode };
  /** A live preview of the hosted careers page: a BrandSurface hero over a ListGroup of the employer's jobs. */
  preview?: { title: ReactNode; content: ReactNode };
  className?: string;
};

/** For employers and the free careers page pitch. Reach claims come from the index. */
export function ForEmployersTemplate({ pitch, howItWorks, preview, className }: ForEmployersTemplateProps) {
  return (
    <PageContainer className={className}>
      <div className="flex flex-col gap-jc-section py-jc-section">
        {pitch}
        <div className="grid gap-jc-section lg:grid-cols-2">
          {howItWorks ? (
            <TemplateSection id="how" title={howItWorks.title}>
              {howItWorks.content}
            </TemplateSection>
          ) : null}
          {preview ? (
            <TemplateSection id="preview" title={preview.title}>
              {preview.content}
            </TemplateSection>
          ) : null}
        </div>
      </div>
    </PageContainer>
  );
}
